import IconArrowLeft from './IconArrowLeft';
import IconArrowRight from './IconArrowRight';

interface Props {
  currentPage: number;
  perPage: number;
  items: unknown[];
  decrementPage: VoidFunction;
  incrementPage: VoidFunction;
}

function PaginationNav({ currentPage, perPage, items, decrementPage, incrementPage }: Props) {
  function getRangeEnd() {
    const end = currentPage * perPage;
    if (end > items.length) {
      return items.length;
    }
    return end;
  }

  return (
    <div>
      <div className="flex items-center justify-end">
        <p className="mr-8 inline text-sm">
          {currentPage * perPage - (perPage - 1)}-{getRangeEnd()}{' '}
          <span className="inline text-sm text-gray-dark">items of</span> {items.length}
        </p>

        {items.length < perPage ? undefined : (
          <>
            <button
              className="group p-8"
              disabled={currentPage === 1}
              onClick={() => {
                if (currentPage > 1) {
                  decrementPage();
                }
              }}
              aria-label="Previous Page"
            >
              <IconArrowLeft className="group-hover:text-gold-darker" />
            </button>

            <p className="inline text-sm">|</p>
            <button
              className="group p-8"
              disabled={getRangeEnd() === items.length}
              onClick={() => {
                if (getRangeEnd() < items.length) {
                  incrementPage();
                }
              }}
              aria-label="Next Page"
            >
              <IconArrowRight className="group-hover:text-gold-darker" />
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default PaginationNav;
